function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Container, CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card, Pill, Empty, Search, Filters, Delta, Pending } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Auth from "../../functions/authenticate";
import account from "../../data/account";
import { brandSvc, invalidateBrandKit } from "../../functions/brand-kit";
import { Link } from "react-router-dom";

/*
 * Settings → Brand kit (REPORT_SCHEDULES_UX.md §7). ONE place for the
 * workspace's logo, accent color, display name, footer line and website.
 * Consumers: scheduled-report emails (masthead/links/footer), the share
 * pages, and email automations via {{brandLogoUrl}} / {{brandAccent}} /
 * {{brandCompany}} / {{brandFooter}} / {{brandWebsite}} merge attributes.
 * API: GET/PUT /v1/reports/brand (AnalyticsService; PUT = owner/administrator).
 */

const HEX = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
const lbl = {
  display: "block",
  fontSize: 10.5,
  letterSpacing: ".7px",
  textTransform: "uppercase",
  color: "var(--plk-text-dim, #9aa4b2)",
  margin: "0 0 4px"
};
const inp = {
  width: "100%",
  padding: "7px 9px",
  fontSize: 13,
  border: "1px solid var(--plk-border, #d5dbe3)",
  borderRadius: 6,
  background: "#fff"
};
const hint = {
  color: "var(--plk-text-muted, #6c757d)",
  fontSize: 12,
  margin: "4px 0 0"
};
class BrandKitComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "save", async () => {
      const {
        logoUrl,
        accent,
        company,
        footer,
        website,
        mailingAddress,
        industry,
        voice,
        bannedWords,
        claimsPolicy,
        audiences
      } = this.state;
      if (accent && !HEX.test(accent.trim())) {
        this.setState({
          note: "Accent must be a hex color like #1a56c4.",
          noteKind: "error"
        });
        return;
      }
      this.setState({
        saving: true,
        note: null
      });
      try {
        await brandSvc().putAsync({
          logoUrl: logoUrl.trim() || null,
          accent: accent.trim() || null,
          company: company.trim() || null,
          footer: footer.trim() || null,
          website: website.trim() || null,
          mailingAddress: mailingAddress.trim() || null,
          industry: industry.trim() || null,
          voice: voice.trim() || null,
          bannedWords: bannedWords.trim() || null,
          claimsPolicy: claimsPolicy.trim() || null,
          audiences: audiences.trim() || null,
          captionFont: this.state.captionFont,
          captionTextColor: this.state.captionTextColor,
          captionBackColor: this.state.captionBackColor,
          captionBackOpacity: Number(this.state.captionBackOpacity),
          captionPosition: this.state.captionPosition,
          captionSize: Number(this.state.captionSize)
        });
        invalidateBrandKit();
        if (this._alive) this.setState({
          saving: false,
          customized: true,
          note: "Saved: scheduled report emails, share pages and automations pick it up on their next send or open.",
          noteKind: "info"
        });
      } catch (e) {
        let msg = "Save failed.";
        try {
          const b = JSON.parse(e.message);
          if (b.error) msg = b.error;
        } catch (x) {/* raw */}
        if (this._alive) this.setState({
          saving: false,
          note: msg,
          noteKind: "error"
        });
      }
    });
    this.state = {
      loading: true,
      canEdit: false,
      saving: false,
      note: null,
      noteKind: "info",
      logoUrl: "",
      accent: "#1f2937",
      company: "",
      footer: "",
      website: "",
      mailingAddress: "",
      industry: "",
      voice: "",
      bannedWords: "",
      claimsPolicy: "",
      audiences: "",
      captionFont: "DejaVu Sans",
      captionTextColor: "#ffffff",
      captionBackColor: "#000000",
      captionBackOpacity: 0.6,
      captionPosition: "bottom",
      captionSize: 0.044,
      defaultCompany: "",
      customized: false,
      modifiedDate: null
    };
    this._alive = true;
  }
  async componentDidMount() {
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    try {
      const b = await brandSvc().getAsync();
      if (!this._alive) return;
      this.setState({
        loading: false,
        canEdit: !!b.canEdit,
        logoUrl: b.logoUrl || "",
        accent: b.accent || "#1f2937",
        company: b.company || "",
        captionFont: b.captionFont || "DejaVu Sans",
        captionTextColor: b.captionTextColor || "#ffffff",
        captionBackColor: b.captionBackColor || "#000000",
        captionBackOpacity: b.captionBackOpacity != null ? Number(b.captionBackOpacity) : 0.6,
        captionPosition: b.captionPosition || "bottom",
        captionSize: b.captionSize != null ? Number(b.captionSize) : 0.044,
        footer: b.footer || "",
        website: b.website || "",
        mailingAddress: b.mailingAddress || "",
        industry: b.industry || "",
        voice: b.voice || "",
        bannedWords: b.bannedWords || "",
        claimsPolicy: b.claimsPolicy || "",
        audiences: b.audiences || "",
        defaultCompany: b.defaultCompany || (account.get() || {}).company || "",
        customized: !!b.customized,
        modifiedDate: b.modifiedDate
      });
    } catch (e) {
      if (this._alive) this.setState({
        loading: false,
        note: "Brand kit could not load.",
        noteKind: "error"
      });
    }
  }
  componentWillUnmount() {
    this._alive = false;
  }
  set(patch) {
    this.setState({
      ...patch,
      note: null
    });
  }
  render() {
    const {
      loading,
      canEdit,
      saving,
      note,
      noteKind,
      logoUrl,
      accent,
      company,
      footer,
      website,
      mailingAddress,
      industry,
      voice,
      bannedWords,
      claimsPolicy,
      audiences,
      defaultCompany
    } = this.state;
    if (loading) return /*#__PURE__*/React.createElement(Loader, null);
    const displayName = company || defaultCompany || "Your company";
    const acc = HEX.test((accent || "").trim()) ? accent.trim() : "#1f2937";
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Settings"
      }, "Settings"), " \xB7 Brand kit"),
      title: "Brand kit",
      subtitle: "Set once \xB7 used by scheduled report emails, public share pages and email automations \xB7 only your brand ever appears, never Plunk's",
      chips: [{
        k: "Access",
        v: canEdit ? "editable" : "read-only"
      }],
      actions: canEdit ? /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
        disabled: saving,
        onClick: this.save
      }, saving ? "Saving…" : "Save brand kit") : null
    }), note && /*#__PURE__*/React.createElement("div", {
      className: "wa-notice" + (noteKind === "error" ? " danger" : "")
    }, note), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "What your emails and share pages carry",
      hint: "available in email automations as {{brandLogoUrl}}, {{brandAccent}}, {{brandCompany}}, {{brandFooter}}, {{brandWebsite}} and {{brandMailingAddress}}",
      span: 8,
      cls: "wa-editor"
    }, !canEdit && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 12px"
      }
    }, "Read-only: an owner or administrator can change these."), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 14,
        maxWidth: 640
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Logo URL"), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: logoUrl,
      disabled: !canEdit,
      placeholder: "https://\u2026/logo.png (PNG or SVG, ~36px tall in email)",
      onChange: e => this.set({
        logoUrl: e.target.value
      })
    }), /*#__PURE__*/React.createElement("p", {
      style: hint
    }, "Hosted image, https. Leave empty to show the company name as text.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Accent color"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "color",
      value: acc,
      disabled: !canEdit,
      onChange: e => this.set({
        accent: e.target.value
      }),
      style: {
        width: 40,
        height: 34,
        padding: 0,
        border: "1px solid var(--plk-border, #d5dbe3)",
        borderRadius: 6,
        background: "#fff"
      }
    }), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inp,
        width: 130
      },
      value: accent,
      disabled: !canEdit,
      onChange: e => this.set({
        accent: e.target.value
      }),
      placeholder: "#1a56c4"
    })), /*#__PURE__*/React.createElement("p", {
      style: hint
    }, "Links, the card's top bar, and the name when there's no logo.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Display name"), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: company,
      disabled: !canEdit,
      placeholder: defaultCompany || "Company name",
      onChange: e => this.set({
        company: e.target.value
      })
    }), /*#__PURE__*/React.createElement("p", {
      style: hint
    }, "Defaults to the workspace name. Also the email's From name.")), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "What you sell ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0
      }
    }, "\xB7 used by every AI prompt (repurpose, rules, Ask Plunk)")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: industry,
      disabled: !canEdit,
      placeholder: "snowboards, bindings and outerwear",
      onChange: e => this.set({
        industry: e.target.value
      })
    }), /*#__PURE__*/React.createElement("p", {
      style: hint
    }, "Shopify stores: filled from your store's product types on the first sync: edit it any time.")), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Brand voice ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0
      }
    }, "\xB7 optional")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: voice,
      disabled: !canEdit,
      placeholder: "playful, expert, no hype",
      onChange: e => this.set({
        voice: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Who you sell to ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0
      }
    }, "\xB7 comma-separated audiences the Content Hub Builder offers")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: audiences,
      disabled: !canEdit,
      placeholder: "park riders, beginners, gift buyers, email subscribers",
      onChange: e => this.set({
        audiences: e.target.value
      })
    }), /*#__PURE__*/React.createElement("p", {
      style: hint
    }, "Blank = the defaults (retail shoppers, email subscribers; wholesale dealers and trade only for wholesale workspaces).")), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Never say ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0
      }
    }, "\xB7 brand safety: comma-separated words the Content Hub blocks before publishing")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: bannedWords,
      disabled: !canEdit,
      placeholder: "cheap, guaranteed, best in the world",
      onChange: e => this.set({
        bannedWords: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Claims policy ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0
      }
    }, "\xB7 what copy may not claim")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: claimsPolicy,
      disabled: !canEdit,
      placeholder: "no health or medical claims; no price-match promises; never name competitors",
      onChange: e => this.set({
        claimsPolicy: e.target.value
      })
    }), /*#__PURE__*/React.createElement("p", {
      style: hint
    }, "The brand-safety check on the Builder's Ship stage flags banned words as critical (blocked unless overridden) and unsupported claims as warnings.")), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Mailing address ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0
      }
    }, "\xB7 required for marketing email (CAN-SPAM)")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: mailingAddress,
      disabled: !canEdit,
      placeholder: "123 Example Street, Suite 100, Anytown, ST 12345",
      onChange: e => this.set({
        mailingAddress: e.target.value
      })
    }), /*#__PURE__*/React.createElement("p", {
      style: hint
    }, "Added automatically, with the unsubscribe link, to any automation email that has no footer of its own.")), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Footer line ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0
      }
    }, "\xB7 optional tagline or phone")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: footer,
      disabled: !canEdit,
      placeholder: "(555) 010-0100 \xB7 Showrooms in Anytown and Springfield",
      onChange: e => this.set({
        footer: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        gridColumn: "1 / -1"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Website"), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: website,
      disabled: !canEdit,
      placeholder: "https://www.yourcompany.com",
      onChange: e => this.set({
        website: e.target.value
      })
    })))), /*#__PURE__*/React.createElement(Card, {
      title: "Captions",
      hint: "How burned-in captions and on-screen text look in Video Edit Mode and narrated videos."
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: 10
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: 12
      }
    }, "Font", /*#__PURE__*/React.createElement("select", {
      value: this.state.captionFont,
      disabled: !canEdit,
      onChange: e => this.set({
        captionFont: e.target.value
      }),
      style: {
        display: "block",
        width: "100%",
        height: 34,
        marginTop: 4
      }
    }, ["DejaVu Sans", "DejaVu Serif", "DejaVu Sans Mono"].map(f => /*#__PURE__*/React.createElement("option", {
      key: f,
      value: f
    }, f.replace("DejaVu ", ""))))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: 12
      }
    }, "Text color", /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        gap: 6,
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "color",
      value: this.state.captionTextColor,
      disabled: !canEdit,
      onChange: e => this.set({
        captionTextColor: e.target.value
      }),
      style: {
        width: 40,
        height: 34,
        padding: 0
      }
    }), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inp,
        width: 110
      },
      value: this.state.captionTextColor,
      disabled: !canEdit,
      onChange: e => this.set({
        captionTextColor: e.target.value
      })
    }))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: 12
      }
    }, "Band color", /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        gap: 6,
        marginTop: 4
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "color",
      value: this.state.captionBackColor,
      disabled: !canEdit,
      onChange: e => this.set({
        captionBackColor: e.target.value
      }),
      style: {
        width: 40,
        height: 34,
        padding: 0
      }
    }), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inp,
        width: 110
      },
      value: this.state.captionBackColor,
      disabled: !canEdit,
      onChange: e => this.set({
        captionBackColor: e.target.value
      })
    }))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: 12
      }
    }, "Band opacity", /*#__PURE__*/React.createElement("input", {
      type: "range",
      min: "0",
      max: "1",
      step: "0.05",
      value: this.state.captionBackOpacity,
      disabled: !canEdit,
      onChange: e => this.set({
        captionBackOpacity: e.target.value
      }),
      style: {
        display: "block",
        width: "100%",
        marginTop: 8
      }
    })), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: 12
      }
    }, "Position", /*#__PURE__*/React.createElement("select", {
      value: this.state.captionPosition,
      disabled: !canEdit,
      onChange: e => this.set({
        captionPosition: e.target.value
      }),
      style: {
        display: "block",
        width: "100%",
        height: 34,
        marginTop: 4
      }
    }, [["bottom", "Bottom"], ["top", "Top"], ["center", "Center"]].map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: 12
      }
    }, "Size", /*#__PURE__*/React.createElement("select", {
      value: String(this.state.captionSize),
      disabled: !canEdit,
      onChange: e => this.set({
        captionSize: e.target.value
      }),
      style: {
        display: "block",
        width: "100%",
        height: 34,
        marginTop: 4
      }
    }, [["0.034", "Small"], ["0.044", "Regular"], ["0.056", "Large"]].map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l))))), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 10,
        padding: "18px 12px",
        borderRadius: 8,
        background: "linear-gradient(135deg, #9aa4b6, #4b5563)",
        display: "flex",
        justifyContent: "center",
        alignItems: this.state.captionPosition === "top" ? "flex-start" : this.state.captionPosition === "center" ? "center" : "flex-end",
        minHeight: 90
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: this.state.captionFont.includes("Serif") ? "serif" : this.state.captionFont.includes("Mono") ? "monospace" : "sans-serif",
        fontWeight: 700,
        color: this.state.captionTextColor,
        background: `${this.state.captionBackColor}${Math.round(Number(this.state.captionBackOpacity) * 255).toString(16).padStart(2, "0")}`,
        padding: "4px 10px",
        borderRadius: 4,
        fontSize: 12 + Number(this.state.captionSize) * 120
      }
    }, "Captions look like this"))), /*#__PURE__*/React.createElement(Card, {
      title: "Preview",
      hint: "illustrative numbers \xB7 the schedule sheet shows the real email for each report",
      span: 4
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: "#f4f4f2",
        padding: 18,
        borderRadius: 10,
        width: "100%",
        maxWidth: 360,
        fontFamily: "-apple-system,'Segoe UI',Arial,sans-serif",
        color: "#26261f"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "0 4px 10px"
      }
    }, logoUrl.trim() ? /*#__PURE__*/React.createElement("img", {
      src: logoUrl.trim(),
      alt: displayName,
      style: {
        height: 30,
        display: "block"
      },
      onError: e => {
        e.target.style.display = "none";
      }
    }) : /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 14,
        fontWeight: 700,
        color: acc
      }
    }, displayName)), /*#__PURE__*/React.createElement("div", {
      style: {
        background: "#fff",
        border: "1px solid #e6e6e0",
        borderTop: `4px solid ${acc}`,
        borderRadius: 10,
        padding: "16px 18px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 15,
        fontWeight: 700
      }
    }, "Marketing Overview"), /*#__PURE__*/React.createElement("div", {
      style: {
        color: "#8a8a7e",
        fontSize: 11,
        margin: "0 0 12px"
      }
    }, "2026-09-01: 2026-09-07 \xB7 vs previous period"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 18
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 17,
        fontWeight: 700
      }
    }, "1.02M"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 9,
        letterSpacing: ".5px",
        color: "#8a8a7e",
        textTransform: "uppercase"
      }
    }, "Impressions"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#0f766e"
      }
    }, "\u25B2 4.2%")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 17,
        fontWeight: 700
      }
    }, "6,410"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 9,
        letterSpacing: ".5px",
        color: "#8a8a7e",
        textTransform: "uppercase"
      }
    }, "Clicks"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 10,
        color: "#c2402f"
      }
    }, "\u25BC 1.1%"))), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 14,
        fontSize: 11
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: acc,
        fontWeight: 600
      }
    }, "Open the live report \u2192"), " ", /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#8a8a7e"
      }
    }, "\xB7 Manage this schedule"))), /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "10px 4px 0",
        fontSize: 10,
        color: "#9a9da6"
      }
    }, [footer.trim(), mailingAddress.trim(), website.trim().replace(/^https?:\/\//, "").replace(/\/$/, "") || (!footer.trim() ? displayName : "")].filter(Boolean).join(" · "))))));
  }
}
export const BrandKitViewComponent = withRouter(BrandKitComponent);
export default {
  BrandKitViewComponent
};